export const AREA_COLORS = ['#22d3ee', '#f97316', '#a78bfa', '#34d399', '#fbbf24', '#f472b6'];

export function areaColor(index: number): string {
  return AREA_COLORS[index % AREA_COLORS.length];
}
